import React, { useRef, useEffect } from 'react'
import cn from 'classnames'
import { formatDistanceToNowStrict, format, isSameDay } from 'date-fns'
import * as Icon from '../Icons'
import styles from './chat.module.css'

function Chat({
  messages,
  disabled,
  type,
  sendMessage,
  relativePosition,
  placeholder = ' TYPE YOUR MESSAGE…',
  username,
}) {
  const replyRef = useRef(null)
  const messagesRef = useRef()

  useEffect(() => {
    if (messagesRef && messagesRef.current) {
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight
    }
  }, [messages])

  function sendHandler() {
    if (replyRef.current.value !== '' && !disabled) {
      sendMessage(replyRef.current.value, !type)
      replyRef.current.value = ''
      replyRef.current.focus()
    }
  }

  const groupedMessages =
    messages && messages.length > 0
      ? messages.reduce((acc, message) => {
          return [
            ...acc,
            {
              ...message,
              ...(acc[acc.length - 1]?.author === message.author &&
              isSameDay(
                new Date(acc[acc.length - 1]?.time),
                new Date(message.time)
              )
                ? { secondary: true }
                : {}),
            },
          ]
        }, [])
      : []

  return (
    <div
      className={cn(styles.chat, {
        [styles.relativePosition]: relativePosition,
      })}
    >
      <h3 className={styles.title}>Messaging</h3>
      <ul className={styles.chatList} ref={messagesRef}>
        <li
          className={styles.chatItem}
          style={{ marginTop: 'auto', opacity: 0 }}
        />
        {relativePosition && (
          <li className={styles.chatItem}>
            <div className={styles.avatar}>
              <Icon.Placeholder
                style={{ color: '#d3fb67', '--bg': '#141520' }}
              />
            </div>
            <div className={styles.messageContent}>
              <p className={styles.chatMeta}>Pixeden Music</p>
              <p
                className={styles.chatMessage}
                style={{ whiteSpace: 'pre-line' }}
              >
                Let us know if you have any questions on anything. <br />
                We are here to help you on your music project.
              </p>
            </div>
          </li>
        )}
        {messages &&
          messages.length > 0 &&
          groupedMessages.map((message) => {
            const selfMessage = message.author === 'Me'
            const date = new Date(message.time)
            const prettyDate = formatDistanceToNowStrict(date, { unit: 'day' })
            return (
              <li
                className={cn(styles.chatItem, {
                  [styles.selfMessage]: selfMessage,
                  [styles.secondary]: message.secondary,
                })}
                key={message.id}
              >
                <div className={styles.avatar}>
                  {selfMessage ? (
                    <div className={styles.profileImage}>
                      <Icon.UserMusic />
                    </div>
                  ) : (
                    <Icon.Placeholder
                      style={{ color: '#d3fb67', '--bg': '#141520' }}
                    />
                  )}
                </div>
                <div className={styles.messageContent}>
                  <p className={styles.chatMeta}>
                    {selfMessage ? username : message.author}
                    <small>
                      {prettyDate === '0 days' ? 'today' : prettyDate}
                    </small>
                  </p>
                  <p
                    title={`Sent on ${format(date, 'yyyy-MM-dd HH:mm:ss')}`}
                    className={styles.chatMessage}
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    {message.content}
                  </p>
                </div>
              </li>
            )
          })}
        {messages &&
          messages.length > 0 &&
          messages[messages.length - 1].author === 'Me' && (
            <li className={cn(styles.chatMeta, styles.autoReply)}>
              We received your messages, we will reply as soon as we can.
            </li>
          )}
      </ul>

      <form
        className={styles.chatForm}
        onSubmit={(e) => {
          e.preventDefault()
          sendHandler()
        }}
        disabled={disabled}
      >
        <textarea
          ref={replyRef}
          className={styles.inputMessage}
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.keyCode === 13 && !e.shiftKey) {
              e.preventDefault()
              sendHandler()
            }
          }}
        />
        <button className={styles.sendButton} type="submit">
          <Icon.Airplane />
        </button>
      </form>
    </div>
  )
}

export default Chat
